<template>
  <div class="container my-4 privacidad">
    <div class="row justify-content-center">
      <div class="col-lg-8">
        <h1 class="h2 mb-1">Política de privacidad</h1>
        <p class="text-muted small">Vida · Última actualización: {{ actualizacion }}</p>

        <h2 class="h5 mt-4">1. Quién es el responsable</h2>
        <p>
          Vida (en adelante, «la app») es una aplicación personal de gestión de gastos, salud y
          organización diaria, disponible en la web (vida.vicenteserran.com) y como app Android.
          El responsable del tratamiento es {{ titular }}.
          <span v-if="contacto">Contacto: <a :href="'mailto:' + contacto">{{ contacto }}</a>.</span>
        </p>

        <h2 class="h5 mt-4">2. Qué datos tratamos</h2>
        <ul>
          <li><strong>Cuenta:</strong> nombre, correo electrónico y contraseña (almacenada cifrada con hash, nunca en texto plano).</li>
          <li><strong>Finanzas:</strong> gastos, ingresos, suscripciones, categorías, gastos planificados, gastos compartidos en grupo y, si lo activas, movimientos de cartera y criptomonedas.</li>
          <li><strong>Salud y bienestar:</strong> datos que decidas conectar o introducir (sueño, actividad, entrenamientos, peso y composición corporal, nutrición).</li>
          <li><strong>Organización personal:</strong> tareas, lista de la compra, recetas, películas, notas e inspiración, y resúmenes de tu día.</li>
          <li><strong>Datos técnicos:</strong> token de sesión y, si activas las notificaciones, la suscripción push de tu dispositivo.</li>
        </ul>
        <p>Solo se tratan los datos de los módulos que usas. No recogemos ubicación, contactos, fotos ni micrófono del dispositivo.</p>

        <h2 class="h5 mt-4">3. Para qué los usamos</h2>
        <p>
          Exclusivamente para prestarte el servicio: mostrar y analizar tus datos, enviarte los
          avisos que actives y sincronizar los servicios que conectes. No vendemos tus datos, no
          los usamos para publicidad ni para elaborar perfiles comerciales.
        </p>

        <h2 class="h5 mt-4">4. Servicios de terceros que tú conectas</h2>
        <p>
          Solo se envían datos a un tercero si tú lo conectas en tu perfil y únicamente lo necesario
          para esa función. Los servicios disponibles son:
        </p>
        <ul>
          <li>Salud y deporte: Oura, Coros, FitDays, TrainingPeaks.</li>
          <li>Finanzas y cripto: BudgetBakers Wallet, Kraken, consultas de direcciones on-chain.</li>
          <li>Google (Gmail y Calendar): lectura de tu correo y calendario para el módulo «Mi día» y la bandeja. El uso de la información recibida de las API de Google se ajusta a la
            <a href="https://developers.google.com/terms/api-services-user-data-policy" target="_blank" rel="noopener">Política de datos de usuario de los servicios de API de Google</a>,
            incluidos los requisitos de uso limitado.</li>
          <li>Productividad y contenido: TickTick, Notion, Trello, Raindrop.</li>
          <li>Inteligencia artificial: algunas funciones (recetas, resúmenes, agentes) envían el texto necesario a un proveedor de IA para generar la respuesta.</li>
        </ul>
        <p>Puedes desconectar cualquiera de ellos en cualquier momento y se dejarán de tratar sus datos.</p>

        <h2 class="h5 mt-4">5. Dónde se guardan y cuánto tiempo</h2>
        <p>
          Los datos se almacenan en un servidor propio, con conexión cifrada (HTTPS). Se conservan
          mientras tengas la cuenta activa y se eliminan al borrarla.
        </p>

        <h2 class="h5 mt-4">6. Tus derechos y cómo eliminar tu cuenta</h2>
        <p>
          Puedes acceder, rectificar y suprimir tus datos, y retirar tu consentimiento. Desde la
          propia app puedes editar tu perfil y <strong>eliminar tu cuenta y todos tus datos</strong>
          en <em>Perfil → Eliminar cuenta</em>. Más detalles en
          <router-link to="/eliminar-cuenta">cómo eliminar tu cuenta</router-link>.
        </p>

        <h2 class="h5 mt-4">7. Menores</h2>
        <p>La app no está dirigida a menores de 14 años y no recoge conscientemente sus datos.</p>

        <h2 class="h5 mt-4">8. Cambios en esta política</h2>
        <p>Si cambia, actualizaremos la fecha de esta página y, si es relevante, te avisaremos en la app.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PoliticaPrivacidad',
  data() {
    return {
      titular: 'Vicente Serran',
      // Correo público de contacto para privacidad (si está vacío no se muestra).
      contacto: 'visego@gmail.com',
      actualizacion: '19 de octubre de 2026'
    };
  }
};
</script>
